"use client"

import React from "react"
import { Controller, useFormContext } from "react-hook-form"

import type { SwitchProps } from "./switch"
import { Switch } from "./switch"

type FormSwitchProps = SwitchProps

export const FormSwitch = React.memo(({ name, ...props }: FormSwitchProps) => {
	const {
		formState: { errors },
		control,
	} = useFormContext()
	const error = errors[name]

	return (
		<Controller
			name={name}
			control={control}
			render={({ field }) => {
				return (
					<Switch
						{...field}
						{...props}
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
						checked={field.value}
						// Spread last so a caller's handler runs alongside the form update
						// instead of replacing it.
						onCheckedChange={(newValue) => {
							field.onChange(newValue)
							props.onCheckedChange?.(newValue)
						}}
						errorMessage={error ? String(error.message) : props.errorMessage}
					/>
				)
			}}
		/>
	)
})
